export default "__VITE_ASSET__DXa3N0iq__"